import * as CONSTANTS from '../../Constants/ActionTypes'
import _ from 'lodash'

let initialState = {
  stateList: {},
  loading: false,
  programsList: [],
  systemsList: [],
  programMetadata: null,
  programFileDownloadLink: null,
  programId: '',
  programDetails: {},
  notFound: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case CONSTANTS.GET_GS_REQUESTS_FAILURE:
      return { ...state, loading: false }
    case CONSTANTS.GET_ALL_SYSTEMS_REQUEST:
      return { ...state, loading: true }
    case CONSTANTS.GET_ALL_SYSTEMS_SUCCESS:
      return { ...state, loading: false, systemsList: action.systemsList }
    case CONSTANTS.GET_ALL_STATES_SUCCESS:
      return { ...state, stateList: action.states }
    case CONSTANTS.ADD_CURRENT_PROGRAM:
      return { ...state, currentProgram: action.payload }
    case CONSTANTS.GET_ALL_PROGRAMS_SUCCESS:
      return { ...state, programsList: action.programsList }
    case CONSTANTS.POST_FILE_SUCCESS:
      return { ...state, programMetadata: action.programMetadata }
    case CONSTANTS.GET_PROGRAM_ENROLLMENT_METADATA_OF_CURRENT_PROGRAM_SUCCESS:
      return { ...state, programMetadata: action.programMetadata }
    case CONSTANTS.DELETE_FILE_SUCCESS:
      return { ...state, programMetadata: action.programMetadata }
    case CONSTANTS.GET_PROGRAM_BY_ID_SUCCESS:
      return { ...state, programDetails: _.get(action, 'payload', {}), programId: _.get(action.payload, 'id', ''), notFound: false }
    case CONSTANTS.GET_PROGRAM_BY_ID_NOT_FOUND:
      return { ...state, notFound: true }
    case CONSTANTS.DOWNLOAD_FILE_SUCCESS:
      return {
        ...state,
        programFileDownloadLink: action.programFileDownloadLink,
      }
    default:
      return state
  }
}
